<template>
  <a :href="articleLink" class="block">
    <div class="relative rounded-[2.4rem] sm:h-[512px] w-full overflow-hidden">
      <img
        :src="imageSrc"
        :alt="article.alt || $t('Article image placeholder')"
        class="w-full h-full object-cover"
        @error="handleImageError"
        loading="lazy"
        decoding="async"
      />

      <div
        class="background_color backdrop-blur-[5.5px] absolute w-full p-[2.4rem] rounded-b-[2.4rem] bottom-0"
      >
        <h4 class="text-left text-white text-[2.4rem] font-semibold mb-4 pt-[2.4rem]">
          {{ article.title }}
        </h4>

        <DoctorImage
          :doctorImage="article.authorImage"
          :doctorName="article.authorName"
        />
      </div>
    </div>
  </a>
</template>

<script>

import DoctorImage from '@/components/blog/articles/doctorImage.vue';

export default {
  name: 'ArticleCard',
  components: {
    DoctorImage
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hasImageError: false
    };
  },
  computed: {
    articleLink() {
      // const categorySlug = this.slugify(this.article.category);
      // const articleSlug = this.slugify(this.article.title);
      return `/blogs/${this.article.category}/${this.article.id}`;
    },
    imageSrc() {
      if (!this.article.image || this.hasImageError) {
        return this.placeholderDataUrl;
      }
      return this.article.image;
    },
    placeholderDataUrl() {
      const w = 1200, h = 800;
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
          <defs>
            <filter id="b" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="60"/>
            </filter>
            <linearGradient id="g" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stop-color="#111827" stop-opacity="0.35"/>
              <stop offset="100%" stop-color="#111827" stop-opacity="0.15"/>
            </linearGradient>
          </defs>

          <!-- Base ligeramente oscura/translúcida (simula el vidrio esmerilado) -->
          <rect width="100%" height="100%" fill="url(#g)"/>

          <!-- Manchas suaves borrosas (simulan blur orgánico) -->
          <g filter="url(#b)">
            <circle cx="${w*0.28}" cy="${h*0.35}" r="${Math.min(w,h)*0.28}" fill="#60A5FA" fill-opacity="0.45"/>
            <circle cx="${w*0.72}" cy="${h*0.60}" r="${Math.min(w,h)*0.35}" fill="#34D399" fill-opacity="0.35"/>
            <circle cx="${w*0.52}" cy="${h*0.18}" r="${Math.min(w,h)*0.20}" fill="#F472B6" fill-opacity="0.40"/>
          </g>
        </svg>
      `;
      return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
    }
  },
  methods: {
    slugify(text) {
      return text.toString().toLowerCase().trim()
    },
    handleImageError() {
      // Evita loops: solo cambia a placeholder una vez
      if (!this.hasImageError) this.hasImageError = true;
    }
  }
}
</script>

<style scoped>

.background_color {
	background: linear-gradient(180deg, rgba(0, 0, 0, 0.24) 48%, #000 100%);
}

</style>
